import React, { memo, useCallback } from 'react';
import { Handle, Position } from 'reactflow';
import Icon from './Icon';
import ConditionDisplay from './ConditionDisplay';
import './CustomNode.css';

export default memo(({ data = {}, id }) => {
  
  // Handle click events with proper event prevention
  const handleAddClick = useCallback((event, handleId) => {
    event.stopPropagation();
    if (window.bubbleInstance) {
      window.bubbleInstance.publishState('add_from_node_id', id);
      window.bubbleInstance.publishState('add_from_handle_id', handleId);
      window.bubbleInstance.triggerEvent('add_node_requested');
    }
  }, [id]);

  // Build CSS classes based on node state
  const nodeClasses = [
    'custom-node',
    'branch-node',
    data.isSelected ? 'selected' : '',
    data.isConnectedToSelectedEdge ? 'connected-to-selected-edge' : ''
  ].filter(Boolean).join(' ');

  return (
    <div className={nodeClasses}>
      {/* Input handle at the top */}
      <Handle type="target" position={Position.Top} className="branch-input-handle" />
      
      {/* Simple circle branch */}
      <div className="branch-circle">
        <Icon name={data.icon || "git-fork"} size={20} weight={data.iconWeight || 'regular'} />
      </div>
      
      {/* Conditions for branch node - positioned differently */}
      {data.conditions && (
        <div className="branch-conditions">
          <ConditionDisplay conditions={data.conditions} />
        </div>
      )}

      {/* Failure output - left */}
      <div className="branch-output branch-output-left">
        <div 
          className="add-node-button-branch branch-left" 
          onClick={(e) => handleAddClick(e, 'false')}
        >
          +
        </div>
        <div className="branch-label failure">Failure</div>
      </div>
      <Handle
        type="source"
        position={Position.Left}
        id="false"
        className="branch-handle-left"
      />

      {/* Success output - right */}
      <div className="branch-output branch-output-right">
        <div 
          className="add-node-button-branch branch-right" 
          onClick={(e) => handleAddClick(e, 'true')}
        >
          +
        </div>
        <div className="branch-label success">Success</div>
      </div>
      <Handle
        type="source"
        position={Position.Right}
        id="true"
        className="branch-handle-right"
      />
    </div>
  );
}); 